import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["timeOfDay", "daysOfWeek", "optionalTimeZoneStrategy"],
  _excluded2 = ["timeOfDay", "daysOfWeek", "optionalTimeZoneStrategy"];
import { Set as ImmutableSet } from 'immutable';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import * as ChronoUnit from 'automation-ui-flow-core/fields/time/ChronoUnit';
import TimeOfDay from 'automation-ui-flow-core/fields/time/TimeOfDay';
import TimeZoneStrategy from 'automation-ui-flow-core/fields/time/TimeZoneStrategy';
export default class TimeDelay extends createImmutableObjectClass({
  timeUnit: ChronoUnit.DAYS,
  delta: 0,
  timeOfDay: null,
  daysOfWeek: [],
  optionalTimeZoneStrategy: null
}, {
  fromJSON: _ref => {
    let {
        timeOfDay,
        daysOfWeek,
        optionalTimeZoneStrategy
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({
      timeOfDay: timeOfDay ? new TimeOfDay(timeOfDay) : null,
      daysOfWeek: ImmutableSet(daysOfWeek),
      optionalTimeZoneStrategy: optionalTimeZoneStrategy ? new TimeZoneStrategy(optionalTimeZoneStrategy) : null
    }, rest);
  },
  toJSON: _ref2 => {
    let {
        timeOfDay,
        daysOfWeek,
        optionalTimeZoneStrategy
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return Object.assign({
      timeOfDay: timeOfDay && timeOfDay.toJSON(),
      daysOfWeek: daysOfWeek.toArray(),
      optionalTimeZoneStrategy: optionalTimeZoneStrategy && optionalTimeZoneStrategy.toJSON()
    }, rest);
  }
}) {
  setTimeUnit(value) {
    return this.set('timeUnit', value);
  }
  setDelta(value) {
    return this.set('delta', value);
  }
  setTimeOfDay(value) {
    return this.set('timeOfDay', value);
  }
  setDaysOfWeek(value) {
    return this.set('daysOfWeek', value);
  }
  setTimeZoneStrategy(value) {
    return this.set('optionalTimeZoneStrategy', value);
  }
}